import { lookupService } from "@/services/app/lookup.service";
import i18n from "@/i18n";
import { sharedHelper, alertHelper } from "@/utils";
import { lookupModel } from "@/models/api/lookup.model";

export const state = {
    meetingRoomDdl: [],
};

export const LOOKUP_MODULE = "app/lookup";

// ACTIONS
export const LOOKUP_MEETING_ROOM = "lookupMeetingRoom";

// MUTATIONS
const MEETING_ROOM_LOOKUP = "meetingRoomLookup";

export const actions = {
    [LOOKUP_MEETING_ROOM]({commit}) {
        return lookupService
            .getMeetingRooms()
            .then((result) => {
                commit(MEETING_ROOM_LOOKUP, {result});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t("message.error")});
            });
    },
};

export const mutations = {
    [MEETING_ROOM_LOOKUP](state, {result}) {
        state.meetingRoomDdl = result.success ? (result.data || []).map(item => lookupModel(item)) : [];
    },
};
